import { useParams } from 'react-router-dom';
import KnowledgeArticlePage from '../components/KnowledgeArticlePage';
import { PET_INSURANCE_CONFIG } from '../data/petArticles';

function PetKnowledgeArticleRoute() {
  const { slug } = useParams<{ slug: string }>();

  return <KnowledgeArticlePage config={PET_INSURANCE_CONFIG} slug={slug ?? ''} />;
}

export default PetKnowledgeArticleRoute;
